import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Verificar se é o erro removeChild específico
    if (error.message && error.message.includes('removeChild')) {
      // Suprimir erro removeChild (problema conhecido do Radix UI + React 19)
      console.warn('ErrorBoundary: Suprimido erro removeChild (problema conhecido Radix UI)');
      return { hasError: false }; // Não mostrar erro ao usuário
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Logar apenas se não for o erro removeChild
    if (!error.message || !error.message.includes('removeChild')) {
      console.error('ErrorBoundary capturou erro:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Algo deu errado.</h2>
          <button onClick={() => window.location.reload()}>
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
